import { ValueObject } from '@nx-smartmonkey/shared/domain';

type VehiclesPermissions =
  | `can_view_vehicles`
  | `can_create_and_delete_vehicles`
  | `can_update_vehicles`
  | `can_dispatch_routes`;
type ClientsPermissions = `can_view_clients` | `can_create_and_delete_clients` | `can_update_clients`;
type SupervisorsPermissions = `can_view_supervisors` | `can_create_and_delete_supervisors` | `can_update_supervisors`;
type PlansPermissions = `can_view_plans` | `can_optimize_plans` | `can_create_and_delete_plans` | `can_update_plans`;
type UsersPermissions = `can_view_users` | `can_create_and_delete_users`;
type GeoFencesPermissions = `can_view_geofences` | `can_manage_geofences`;

export type ProjectPermission =
  | `can_manage_drivers_app`
  | `can_manage_customers_app`
  | `can_manage_supervisors_app`
  | `can_update_project`
  | `can_view_project`
  | `can_view_stops`
  | `can_update_stops`
  | `can_create_stops`
  | `can_delete_stops`
  | `can_view_routes`
  | `can_update_routes`
  | `can_create_and_delete_routes`
  | `can_create_tasks`
  | `can_manage_traffic`
  | `can_view_analytics`
  | PlansPermissions
  | UsersPermissions
  | VehiclesPermissions
  | ClientsPermissions
  | SupervisorsPermissions
  | GeoFencesPermissions;

interface ProjectCredentialsProps {
  id: string;
  permissions: ProjectPermission[];
}

export class ProjectCredentials extends ValueObject<ProjectCredentialsProps> {
  private constructor(props: ProjectCredentialsProps) {
    super(props);
  }

  static create(props: ProjectCredentialsProps): ProjectCredentials {
    return new ProjectCredentials(props);
  }

  get id(): string {
    return this.props.id;
  }

  test(permission: ProjectPermission): boolean {
    return this.props.permissions.includes(permission);
  }
  get permissions(): ProjectPermission[] {
    return this.props.permissions;
  }
}
